import { Link } from "react-router-dom"; // Import Link for page navigation

export default function Menu() {
    return (
        <>
            <ul className="navigation">
                <li>
                    <a href="https://shacaresupport.com.au/#banner">Home</a> {/* Scroll to Home section */}
                </li>
                <li>
                    <a href="https://service.shacaresupport.com.au/">Services</a> {/* Navigate to Services Page */}
                </li>
                <li>
                    <a href="https://shacaresupport.com.au/#about">About</a> {/* Scroll to About section */}
                </li>
                <li>
                    <a href="https://shacaresupport.com.au/#contact">Contact</a> {/* Scroll to Contact section */}
                </li>
            </ul>
        </>
    );
}
